import React from 'react';
import PropTypes from 'prop-types';

const LeftNavArrowCloud = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <filter id="a">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.400000 0 0 0 0 0.521569 0 0 0 0 1.000000 0 0 0 1.000000 0"
          />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFF"
          d="M0 50.28C0 22.821 22.177.561 49.533.561V100C22.177 100 0 77.74 0 50.28z"
        />
        <g filter="url(#a)" transform="rotate(-90 50 50)">
          <path
            fill="#FFF"
            fillRule="nonzero"
            d="M48.938 41.028l.001-21.4-6.395 6.518-1.357-1.383 7.991-8.146a.915.915 0 011.313-.004c1.943 1.978 7.56 7.704 7.975 8.126l.024.024-1.357 1.383-6.394-6.517v21.399h-1.8z"
          />
        </g>
      </g>
    </svg>
  );
};

LeftNavArrowCloud.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
};
LeftNavArrowCloud.defaultProps = {
  height: 100,
  width: 50,
};

export default LeftNavArrowCloud;
